module.exports = __webpack_public_path__ + "img/vidlis.e15883a3.svg";